import script from "./SubmitDrawdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmitDrawdown.vue?vue&type=script&setup=true&lang=ts"

import "./SubmitDrawdown.vue?vue&type=style&index=0&id=77bef46e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77bef46e"]])

export default __exports__